import { Injectable } from '@angular/core';
import { TableColumnService } from '../services/table-column.service';
import { PackageColumnEnum } from '../../../enum/package-column.enum';
import { Package } from '../../../models/package';
import { EntityEnum } from '../../../enum/entity.enum';
import { TableColumnProvider } from '../../../interfaces/table-column-provider';
import { PackagingTypeName } from '../../../utils/packaging-type-name';
import { CurrencyService } from '../services/currency.service';
import { Dimensions } from '../../../utils/dimensions';
import { Weight } from '../../../utils/weight';

@Injectable({
    providedIn: 'root'
})
export class PackageColumnsService implements TableColumnProvider {

    constructor(private tableColumnService: TableColumnService, private currencyService: CurrencyService) {
        this.tableColumnService.registerProvider(this);
    }

    get(id: string): any {
        switch (id) {
            case PackageColumnEnum.PACKAGE_DESCRIPTION:
                return {
                    id: PackageColumnEnum.PACKAGE_DESCRIPTION,
                    caption: $localize`Description`,
                    width: 200,
                    sort: 'description',
                    render: (pkg: Package) => pkg.description
                };
                case PackageColumnEnum.PACKAGE_WEIGHT:
                    return {
                        id: PackageColumnEnum.PACKAGE_WEIGHT,
                        caption: $localize`Weight`,
                        width: 100,
                        sort: 'weight',
                        render: (pkg: Package) => Weight.render(pkg.weight, pkg.weightUnit)
                    };
            case PackageColumnEnum.PACKAGE_DIMS:
                return {
                    id: PackageColumnEnum.PACKAGE_DIMS,
                    caption: $localize`Dimensions`,
                    width: 150,
                    sort: null,
                    render: (pkg: Package) => Dimensions.triplet(pkg.length, pkg.width, pkg.height, pkg.dimensionUnit)
                };
            case PackageColumnEnum.PACKAGE_INSURANCE:
                return {
                    id: PackageColumnEnum.PACKAGE_INSURANCE,
                    caption: $localize`Insurance`,
                    width: 100,
                    sort: 'insurance',
                    render: (pkg: Package) => pkg.value ? this.currencyService.render(pkg.value, pkg.currency) : ''
                };
            case PackageColumnEnum.PACKAGE_TYPE:
                return {
                    id: PackageColumnEnum.PACKAGE_TYPE,
                    caption: $localize`Type`,
                    width: 100,
                    sort: 'packageType',
                    render: (pkg: Package) => PackagingTypeName.describe(pkg.packagingType)
                };
        }
    }

    ids(): string[] {
        return [
            PackageColumnEnum.PACKAGE_DESCRIPTION,
            PackageColumnEnum.PACKAGE_WEIGHT,
            PackageColumnEnum.PACKAGE_DIMS,
            PackageColumnEnum.PACKAGE_INSURANCE,
            PackageColumnEnum.PACKAGE_TYPE
        ];
    }

    supports(entityClass: string): boolean {
        return entityClass === EntityEnum.PACKAGE;
    }
}
